import { render, staticRenderFns } from "./YourBadgesTable.vue?vue&type=template&id=0a0bb459&scoped=true"
import script from "./YourBadgesTable.vue?vue&type=script&lang=js"
export * from "./YourBadgesTable.vue?vue&type=script&lang=js"
import style0 from "./YourBadgesTable.vue?vue&type=style&index=0&id=0a0bb459&prod&lang=css"
import style1 from "./YourBadgesTable.vue?vue&type=style&index=1&id=0a0bb459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0bb459",
  null
  
)

export default component.exports